/*
 * pdp-code-deal.js — Ladypolitan
 * -----------------------------------------------------------------------------
 * Zeigt auf der PDP einen Inline-Sale-Preis (unter dem Preis) mit dem im
 * WARENKORB aktiven Gutschein + dem daraus resultierenden Sale-Preis (Code-Preis
 * rot, alter Preis durchgestrichen, −%). Anzeige NUR, wenn der Code
 * im Cart wirklich greift (= er hat eine line-level Allocation in /cart.js).
 * KEINE Vorab-Kenntnis der Shopify-Codes nötig — alles kommt live aus /cart.js.
 *
 * Sicherheit gegen collection-gebundene Codes (z.B. "15% nur auf BF21"):
 *   Der Sale-Preis wird nur gezeigt, wenn
 *     (a) genau dieses Produkt im Cart rabattiert ist (exakte Entitlement-Info), ODER
 *     (b) der %-Code ALLE bezahlten Cart-Zeilen rabattiert (greift also breit).
 *   Sonst: nichts. Geschenk-/0-€-Zeilen werden ignoriert.
 *
 * Preis-Mathematik spiegelt Shopify: Rabatt/Stück = round(price * pct).
 */
(function () {
  if (window.__lpPdpCodeDeal) return;
  window.__lpPdpCodeDeal = true;

  var info = null; // { pct, title, coversAll, byHandle:{handle:true} } | null

  function fmt(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isGift(it) {
    var p = it && it.properties;
    if (!p) return false;
    if (Array.isArray(p)) {
      for (var i = 0; i < p.length; i++) {
        if (p[i] && p[i][0] === '_gift' && (p[i][1] === 'true' || p[i][1] === true)) return true;
      }
      return false;
    }
    return p._gift === 'true' || p._gift === true;
  }

  // XHR statt fetch: umgeht App-fetch-Wrapper (SellEasy o.ä.), die Cart-Requests stören.
  function getCart() {
    return new Promise(function (resolve, reject) {
      try {
        var x = new XMLHttpRequest();
        x.open('GET', '/cart.js', true);
        x.onreadystatechange = function () {
          if (x.readyState !== 4) return;
          if (x.status >= 200 && x.status < 300) {
            try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); }
          } else { reject(new Error('HTTP ' + x.status)); }
        };
        x.onerror = function () { reject(new Error('network')); };
        x.send();
      } catch (e) { reject(e); }
    });
  }

  function analyze(cart) {
    if (!cart) return null;
    var paid = (cart.items || []).filter(function (it) { return !isGift(it) && it.price > 0; });

    // 1) Voll-Deal aus Line-Allocations (mit Preis) — bevorzugt + entitlement-genau.
    if (paid.length) {
      // Aktive Prozent-Allocation finden (höchster %-Satz, falls mehrere)
      var title = null, pctVal = 0;
      paid.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var da = a.discount_application || {};
          if (da.value_type === 'percentage') {
            var v = parseFloat(da.value) || 0;
            if (v > pctVal) { pctVal = v; title = da.title; }
          }
        });
      });
      if (!title || pctVal <= 0) return null; // Artikel da, Code greift aber auf keinen → nichts (sicher)

      var res = { mode: 'deal', pct: pctVal / 100, title: title, coversAll: true, byHandle: {} };
      paid.forEach(function (it) {
        var has = (it.line_level_discount_allocations || []).some(function (a) {
          var da = a.discount_application || {};
          return da.value_type === 'percentage' && da.title === title;
        });
        if (!has) res.coversAll = false;
        if (has && it.handle) res.byHandle[it.handle] = true;
      });
      return res;
    }

    // 2) Leerer Cart, aber ein Gutschein-Code ist hinterlegt (z.B. via /discount/CODE-Link)
    //    → reine Bestätigung OHNE Preis. Den %-Wert kennt Shopify bei leerem Cart nicht
    //    (discount_codes mit applicable:false, keine Allocation) → daher kein Preis/−%.
    //    NUR bei leerem Cart, damit die entitlement-Sicherheit (oben) erhalten bleibt.
    var codes = cart.discount_codes || [];
    for (var ci = 0; ci < codes.length; ci++) {
      if (codes[ci] && codes[ci].code) return { mode: 'info', title: codes[ci].code };
    }
    return null;
  }

  function pctLabel(pct) {
    var n = Math.round(pct * 1000) / 10; // eine Nachkommastelle
    return (n % 1 === 0) ? n.toFixed(0) : n.toFixed(1).replace('.', ',');
  }

  function hide(el) { el.hidden = true; el.innerHTML = ''; }

  function renderEl(el) {
    if (!info) { hide(el); return; }

    // Streichpreis-Regel: Hat das Produkt bereits einen Sale (compare_at_price > price),
    // ist der reduzierte Preis schon sichtbar → Code-Deal komplett ausblenden (kein Doppel-Sale).
    var cmp = parseInt(el.getAttribute('data-variant-compare'), 10) || 0;
    var basePrice = parseInt(el.getAttribute('data-variant-price'), 10) || 0;
    if (cmp > basePrice) { hide(el); return; }

    // Info-Modus: Code hinterlegt (z.B. via /discount-Link), aber leerer Cart → reine
    // Bestätigung OHNE Preis, damit der Kunde direkt auf der PDP sieht, dass sein Code
    // registriert ist. Den %-Wert/Preis kennt Shopify bei leerem Cart nicht.
    if (info.mode === 'info') {
      el.className = 'lp-pdp-deal lp-pdp-deal--info';
      el.innerHTML =
        '<span class="lp-pdp-deal__inner">' +
          '<span class="lp-pdp-deal__label">✓ Code ' + esc(info.title) + ' aktiv</span>' +
          '<span class="lp-pdp-deal__note">wird im Warenkorb verrechnet</span>' +
        '</span>';
      el.hidden = false;
      return;
    }

    var price = parseInt(el.getAttribute('data-variant-price'), 10) || 0;
    if (!price) { hide(el); return; }
    var handle = el.getAttribute('data-handle');
    var applies = (handle && info.byHandle[handle]) || info.coversAll;
    if (!applies) { hide(el); return; }
    el.className = 'lp-pdp-deal';
    var disc = Math.round(price * info.pct);
    var unit = Math.max(0, price - disc);
    // Reihenfolge: erst Sale-Preis + −%, dann der Code-Hinweis (rechts daneben).
    // Kein Doppelpreis (regulärer Preis steht bereits im Theme-Preis-Block).
    el.innerHTML =
      '<span class="lp-pdp-deal__inner">' +
        '<span class="lp-pdp-deal__row">' +
          '<span class="lp-pdp-deal__val">' + fmt(unit) + '</span>' +
          '<span class="lp-pdp-deal__pct">−' + pctLabel(info.pct) + ' %</span>' +
        '</span>' +
        '<span class="lp-pdp-deal__label">✓ Code ' + esc(info.title) + ' aktiv</span>' +
      '</span>';
    el.hidden = false;
  }

  // Free-Shipping-Hinweis dynamisch: fällt der Preis MIT Code unter 49 €, muss
  // "Kostenloser Versand ab 49€" stehen. Server rendert nur nach regulärem Preis,
  // der Discount kann ein Produkt aber unter die Schwelle drücken.
  var SHIP_THRESHOLD = 4900;                       // 49,00 € (analog Theme: frei wenn > 4900)
  var SHIP_BELOW = 'Kostenloser Versand ab 49€';

  function updateShipping() {
    var els = document.querySelectorAll('.free-shipping');
    if (!els.length) return;
    var deal = document.querySelector('[data-pdp-code-deal]');
    var regular = deal ? (parseInt(deal.getAttribute('data-variant-price'), 10) || 0) : 0;
    var applies = false, unit = regular;
    if (info && deal && regular) {
      var handle = deal.getAttribute('data-handle');
      applies = (handle && info.byHandle[handle]) || info.coversAll;
      if (applies) unit = Math.max(0, regular - Math.round(regular * info.pct));
    }
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-lp-ship-orig') === null) {
        el.setAttribute('data-lp-ship-orig', el.innerHTML); // Theme-Default sichern
      }
      // Mit Code unter 49 € → Schwellen-Hinweis, sonst Theme-Default wiederherstellen.
      el.innerHTML = (applies && unit <= SHIP_THRESHOLD)
        ? SHIP_BELOW
        : el.getAttribute('data-lp-ship-orig');
    }
  }

  function renderAll() {
    var els = document.querySelectorAll('[data-pdp-code-deal]');
    for (var i = 0; i < els.length; i++) renderEl(els[i]);
    updateShipping();
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    getCart().then(function (cart) {
      info = analyze(cart);
      pending = false;
      renderAll();
    }).catch(function () { pending = false; /* leise scheitern */ });
  }

  // Varianten-Wechsel → passenden Deal (per Varianten-ID) neu rechnen
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v) return;
    var els = document.querySelectorAll('[data-pdp-code-deal]');
    for (var i = 0; i < els.length; i++) {
      var ids = (els[i].getAttribute('data-variant-ids') || '').split(',');
      if (ids.indexOf(String(v.id)) !== -1) {
        if (v.price != null) els[i].setAttribute('data-variant-price', v.price);
        els[i].setAttribute('data-variant-compare', (v.compare_at_price != null ? v.compare_at_price : 0));
        renderEl(els[i]);
      }
    }
    updateShipping();
  });

  // Cart-Änderungen (ATC, Mengen, Gutschein) → neu bewerten
  ['cart:updated', 'cart:build', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { refresh(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
